"use strict";

/**
 * @module Routing
 */
var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return _extendStatics(d, b);
  };
  return function (d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    _extendStatics(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TimeSeriesCacheEntry = void 0;
var topic_cache_datatype_entry_1 = require("./../routing/topic-cache-datatype-entry");
var time_series_event_datatype_1 = require("./../timeseries/time-series-event-datatype");
/**
 * Extends {@link DatatypeCacheEntry} to handle time series events with a given
 * data type
 */
var TimeSeriesCacheEntry = /** @class */function (_super) {
  __extends(TimeSeriesCacheEntry, _super);
  /**
   * Create a new TimeSeriesCacheEntry instance
   *
   * @param streams        the stream adapters
   * @param path           the topic path
   * @param specification  the topic specification
   * @param datatype       the data type of the entry
   */
  function TimeSeriesCacheEntry(streams, path, specification, datatype) {
    return _super.call(this, streams, path, specification, time_series_event_datatype_1.TimeSeriesEventDataType.create(datatype)) || this;
  }
  return TimeSeriesCacheEntry;
}(topic_cache_datatype_entry_1.DatatypeCacheEntry);
exports.TimeSeriesCacheEntry = TimeSeriesCacheEntry;